import React, { Suspense, useState } from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { createStyles, withStyles, WithStyles } from '@material-ui/core';
import { ErrorBoundary } from 'core';
import { times } from 'lodash';

import { QueryListSquigglies, QueryListSquiggliesProps } from 'deprecated/queries';

import { ContentLoaderListItem, Popper, PopperProps, ToolbarSquigglies } from 'components/v2';

const styles = () =>
  createStyles({
    infiniteScrollWrapper: {
      overflow: 'auto',
      height: '100%',
    },
  });

const messages = defineMessages({
  search: {
    id: 'deprecated.query-triggers.PopperSquigglies.search',
    defaultMessage: 'Find a squiggly',
  },
});

export interface PopperSquiggliesProps extends Omit<PopperProps, 'classes' | 'children'>, WithStyles<typeof styles> {
  squigglies: QueryListSquiggliesProps['squigglies'];
  includePatientFormTemplates?: boolean;
  includeLumabotFlowTemplates?: boolean;
  onSquigglySelected?: QueryListSquiggliesProps['onSquigglySelected'];
}

// TODO rename to PopperSquigglies
const PopperSquigglies: React.FC<PopperSquiggliesProps> = ({
  classes,
  squigglies,
  onSquigglySelected,
  includePatientFormTemplates = true,
  includeLumabotFlowTemplates = true,
  ...rest
}) => {
  const { formatMessage } = useIntl();
  const [query, setQuery] = useState('');

  return (
    <Popper {...rest}>
      <ToolbarSquigglies
        TextFieldSearchProps={{
          placeholder: formatMessage(messages.search),
          size: 'small',
          value: query,
          onChange: setQuery,
        }}
      />
      <div className={classes.infiniteScrollWrapper}>
        <ErrorBoundary>
          <Suspense
            fallback={times(15, (i) => (
              <ContentLoaderListItem width={300} height={59} includeSecondaryText key={i} />
            ))}
          >
            <QueryListSquigglies
              variables={{
                regex: query && `(?i)${query}`,
                includePatientFormTemplates,
                includeLumabotFlowTemplates,
              }}
              squigglies={squigglies}
              dense
              disablePadding
              onSquigglySelected={onSquigglySelected}
              // WORKAROUND we need to pass the `query` as well b/c we're filtering some squigglies
              // that are hardcoded in FE instead of fetching them through GQL
              query={query}
            />
          </Suspense>
        </ErrorBoundary>
      </div>
    </Popper>
  );
};

export default withStyles(styles)(PopperSquigglies);
